var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeShowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7C9.243 7 7 9.243 7 12C7 14.757 9.243 17 12 17C14.757 17 17 14.757 17 12C17 9.243 14.757 7 12 7ZM12 16C9.7945 16 8 14.2055 8 12C8 9.7945 9.7945 8 12 8C14.2055 8 16 9.7945 16 12C16 14.2055 14.2055 16 12 16Z",
    fill: "#031434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
    fill: "#031434"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8905 11.5415C21.601 7.0505 17.136 4 12 4C6.864 4 2.399 7.0505 0.1095 11.5415C-0.0365 11.8275 -0.0365 12.173 0.1095 12.459C2.399 16.9495 6.864 20 12 20C17.136 20 21.601 16.9495 23.8905 12.4585C24.0365 12.1725 24.0365 11.8275 23.8905 11.5415ZM12 19C7.415 19 3.2 16.3195 1.0005 11.9955C3.2 7.6805 7.415 5 12 5C16.585 5 20.8 7.6805 22.9995 12.0045C20.8 16.3195 16.585 19 12 19Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShowIcon);
export default __webpack_public_path__ + "static/media/eye_show_icon.95cb63a585643e657f67a47c191b83b9.svg";
export { ForwardRef as ReactComponent };